import React from "react";
import style from './index.module.scss';
import tianzhangchain from '@imgs/tianzhangchain.png';
import { HeaderLogin } from "./HeaderLogin";

export const Header = (props: any) => {
    const { tabName, tabClick, setLoginVisible } = props;

    return (
        <div className={style.header}>
        <div className={style.header_c}>
          {/* logo图片 */}
          {/* <ChainSelect value={chainId} onChange={updateChainId} onInit={onInit} /> */}
          <img onClick={() => tabClick('home')} src={tianzhangchain} className={style.header_logo} />
          {/* 路由跳转tab栏 */}
          <div className={style.header_tab}>
            <div className={tabName === 'home' ? style.header_tab_item_active : style.header_tab_item} onClick={() => tabClick('home')}>
              首页
            </div>
            <div className={tabName === 'block' ? style.header_tab_item_active : style.header_tab_item} onClick={() => tabClick('block')}>
              区块
            </div>
            <div className={tabName === 'fileValidation' ? style.header_tab_item_active : style.header_tab_item} onClick={() => tabClick('fileValidation')}>
              文件验证
            </div>
            <div className={tabName === 'forensics' ? style.header_tab_item_active : style.header_tab_item} onClick={() => tabClick('forensics')}>
              证据提取
            </div>  
          </div>
          {/* 登录模块 */}
          <HeaderLogin setLoginVisible={setLoginVisible} />
        </div>
      </div>
    )
}
